import React from "react";
import PropTypes from "prop-types";
import BroadcastsListItemOptions from "../broadcasts/BroadcastsListItemOptions";
import BroadcastsCampaignToggle from "../broadcasts/BroadcastsCampaignToggle";
import BroadcastsGroupsSmallList from "../broadcasts_groups/BroadcastsGroupsSmallList";
import { reportingGoals } from "../../src/reportingGoals";

const BroadcastsListItem = (props) => {
  const websiteLink = "/websites/" + props.broadcast.website_id;
  const broadcastLink =
    websiteLink + "/broadcasts/" + props.broadcast.id + "/edit";
  const goals = reportingGoals(props.website);

  const changeBadge = (change) => {
    const value = change == null ? null : Number(change);
    const label = value == null ? "—" : `${Math.abs(Math.round(value))}%`;
    const isZero = value == null || value === 0;
    const style = {
      display: "inline-flex",
      alignItems: "center",
      padding: "2px 8px",
      borderRadius: "999px",
      fontSize: "11px",
      fontWeight: 500,
      marginTop: "4px",
      background: isZero ? "#f3f4f6" : value > 0 ? "#dcfce7" : "#fee2e2",
      color: isZero ? "#374151" : value > 0 ? "#166534" : "#991b1b",
    };

    const arrow =
      value > 0 ? (
        <svg
          style={{
            width: "12px",
            height: "12px",
            marginRight: "4px",
            transform: "rotate(-45deg)",
          }}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      ) : value < 0 ? (
        <svg
          style={{
            width: "12px",
            height: "12px",
            marginRight: "4px",
            transform: "rotate(45deg)",
          }}
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fillRule="evenodd"
            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      ) : null;

    return (
      <span style={style}>
        {arrow}
        {label}
      </span>
    );
  };

  return (
    <React.Fragment>
      <div data-id={props.broadcast.id} className="BroadcastsListItem">
        <div className="broadcasts-list-name-column">
          <a href={broadcastLink}>
            <div className="row hard-center">
              <p
                className="light ellipsis"
                data-toggle="tooltip"
                data-placement="top"
                title={props.broadcast.name}
                style={{ textTransform: "capitalize", margin: "0" }}
              >
                {props.broadcast.name}
              </p>
            </div>
          </a>
          <div className="row hard-center">
            <BroadcastsGroupsSmallList {...props} />
          </div>
        </div>
        <div className="broadcasts-list-metrics">
          <a
            href={broadcastLink}
            className="broadcasts-list-row-column broadcasts-list-metric"
          >
            <p className="light ellipsis">{props.broadcast.ctas.length}</p>
          </a>
          <a
            href={broadcastLink}
            className="broadcasts-list-row-column broadcasts-list-metric broadcasts-list-metric-wide"
          >
            <p className="light ellipsis">
              {numberWithCommas(props.broadcast.views)}
            </p>
            {changeBadge(props.broadcast.views_change)}
          </a>
          <a
            href={broadcastLink}
            className="broadcasts-list-row-column broadcasts-list-metric broadcasts-list-metric-wide"
          >
            <p className="light ellipsis">
              {numberWithCommas(props.broadcast.conversions)} (
              {parseFloat(props.broadcast.conversion_rate).toFixed(0)}%)
            </p>
            {changeBadge(props.broadcast.conversions_change)}
          </a>
          {goals.checkouts && (
            <a
              href={broadcastLink}
              className="broadcasts-list-row-column broadcasts-list-metric"
            >
              <p className="light ellipsis">
                {props.currency}
                {numberWithCommas(props.broadcast.revenue)}
              </p>
              {changeBadge(props.broadcast.revenue_change)}
            </a>
          )}
          {goals.bookings && (
            <a
              href={broadcastLink}
              className="broadcasts-list-row-column broadcasts-list-metric"
            >
              <p className="light ellipsis">
                {numberWithCommas(props.broadcast.bookings || 0)}
              </p>
              {changeBadge(props.broadcast.bookings_change)}
            </a>
          )}
          {goals.custom && (
            <a
              href={broadcastLink}
              className="broadcasts-list-row-column broadcasts-list-metric"
            >
              <p className="light ellipsis">
                {numberWithCommas(props.broadcast.custom_goals || 0)}
              </p>
              {changeBadge(props.broadcast.custom_goals_change)}
            </a>
          )}
          <div className="broadcasts-list-row-column broadcasts-list-status-column">
            <BroadcastsCampaignToggle {...props} />
          </div>
          <div className="broadcasts-list-row-column broadcasts-list-options-column sticky-options-col">
            <BroadcastsListItemOptions {...props} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BroadcastsListItem;
